import { render } from "./UserNotification.vue?vue&type=template&id=01c40553"
import script from "./UserNotification.vue?vue&type=script&lang=js"
export * from "./UserNotification.vue?vue&type=script&lang=js"

import "./UserNotification.vue?vue&type=style&index=0&id=01c40553&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__